import React from "react";
import styled from "styled-components";
import {boxBorderColour, boxShadowColour, viewAndSubdivideButtonColour} from "../../../../style/styleConsts";
import {Link} from "react-router-dom";

const Container = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    flex-grow: 0;
    flex-shrink: 0;
    box-shadow: ${boxShadowColour} 0px 2px 1px 0px;
    border-top: 1px solid ${boxBorderColour};
    margin-top: auto;
    
    cursor: pointer;
    color: inherit;
    white-space: nowrap;
    text-decoration: none;    
    transition: background-color 0.2s ease;
    
    :hover {
        background-color: ${viewAndSubdivideButtonColour};
    }
`;

const ViewAndSubdivideButton = ({onViewClick, url}) => {
    return <Container className="t-view-and-subdivide-button"
                      to={url}
                      onClick={onViewClick}>
        <div>View & Subdivide Whole List</div>
    </Container>;
};

export default ViewAndSubdivideButton;